import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { ArrayUtil } from '../classes/array.util';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'userIsAllowedTo' })
export class UserIsAllowedToPipe implements PipeTransform {
    private readonly userService = inject(UserService);

    /**
     * Gets a permission or an array of permissions and returns true if user is allowed, false otherwise
     * Usage: @if ((permissions.GET_PRODUCTS | userIsAllowedTo) && booleanCondition)
     * @param {string | string[]} permission
     * @returns {boolean}
     */
    public transform(permission: string | string[]): boolean {
        const userPermissions = this.userService.getLoggedInUser()?.permissions ?? [];
        const requestedPermissions = Array.isArray(permission) ? permission : [permission];
        return ArrayUtil.intersection(requestedPermissions, userPermissions).length === requestedPermissions.length;
    }
}
